import type { ThunkExperiments } from '@library/experimentation'

import { hasConsentForAnalytics } from 'routes/Home/homeUtils'
import { getSignupMotivations } from 'routes/Signup/signupSelectors'
import { getIsAuthenticated } from 'selectors/auth'

import type { GetState } from '../../fetchData/types'

export function getAvailableSignupMotivations(
  getState: GetState,
  { experiments }: ThunkExperiments,
) {
  const state = getState()
  const isAuthenticated = getIsAuthenticated(state)

  const signupMotivations = getSignupMotivations(state)

  const hasAcceptedCookies = hasConsentForAnalytics()
  const shouldBeAllocatedToExperiment = !isAuthenticated && hasAcceptedCookies
  const hasSignupMotivations = signupMotivations.toArray().length > 0

  const { enabled, variationKey } =
    experiments && shouldBeAllocatedToExperiment
      ? experiments.decide('beetroots_ofx_enable_signup_motivations')
      : { enabled: false, variationKey: undefined }

  if (enabled && variationKey === 't1' && hasSignupMotivations) {
    return signupMotivations.toArray()
  }

  return undefined
}
